<template>
	<vxe-modal :loading="loading" v-model="modalShow" width="1000" height="600" show-footer destroy-on-close
		@show="init" @hide="previewHide">
		<template #title>
			<span>{{title}}</span>
		</template>
		<!-- 		<template #corner>
			<vxe-icon name="bell-fill"></vxe-icon>
			<vxe-icon name="minus"></vxe-icon>
		</template> -->
		<template #default>
			<div class="full flex" style="flex-direction: column;" ref="filemodel">
				<div ref="wordarticle" class="wordarticle" style="position: relative;overflow: auto;flex: 1;">
					<div class="contract_box" id="contract_box" @mousemove="moveing" ref="contract_box"
						style="position: relative;">
						<div class="audit_preload_box zhang" id="audit_preload_box" style="position: relative;"></div>
						<template v-if="pdfurl">
							<pdf class="pdfPage" v-for="i in pdfpage" :key="i" :page="i" :src="pdfurl"></pdf>
						</template>


						<div class="watermark" v-if="seal.length!=0"
							style="position: absolute;left: 0;top: 0;margin: 10px;">
							<span>{{'审核人：' + getstaff(row.auditorstaffid)}}</span>
							<span style="margin-left: 10px;">{{'审核时间：' + timestampToDate(row.commit_time)}}</span>
						</div>

						<div class="full" v-if="type=='audit'" @contextmenu.prevent="setContextMenuData($event,'add')">
						</div>
						<div class="seal" @mousedown.prevent="movestart($event,item.id)" @mouseup.prevent="moveend"
							@contextmenu.prevent="setContextMenuData($event,'del',item.id)" v-for="(item,index) in seal"
							:style="{left:item.x+'px',top:item.y+'px'}" :key="index">
							<img crossOrigin="anonymous" style="width: 100%;pointer-events: none;user-select: none;"
								:src="item.url" />
						</div>
					</div>
				</div>
			</div>
			<vue-context-menu :key="menuKey" :contextMenuData="contextMenuData" style="padding: 0 10px;"
				@addseal="addseal" @delseal="delseal" @clear="clear" v-show="menuShow">
			</vue-context-menu>
		</template>
		<template slot="footer" v-if="type=='download'">
			<vxe-button status="primary" content="下载" @click="download"></vxe-button>
		</template>
		<template slot="footer" v-if="type!='download'">
			<template v-if="type=='audit'">
				<vxe-button status="success" content="下载" @click="download"></vxe-button>
				<vxe-button content="取消审核" @click="cancle"></vxe-button>
				<vxe-button status="primary" content="确认审核" @click="submit"></vxe-button>
			</template>
			<template v-else>
				<vxe-button status="success" content="下载" @click="download"></vxe-button>
				<vxe-button content="返回" @click="cancle"></vxe-button>
			</template>
		</template>
	</vxe-modal>
</template>
<style scoped>
	.seal {
		position: absolute;
		width: 150px;
	}
</style>

<script>
	import html2canvas from 'html2canvas';
	import {
		renderAsync
	} from 'docx-preview'
	import {
		jsPDF
	} from "jspdf";
	import pdf from 'vue-pdf'
	export default {
		name: '',
		props: {
			type: {
				type: String,
				default: () => {
					return 'preview'
				}
			},
			form: {
				type: Object,
				default: () => {
					return null
				}
			},
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			comapnyid: {

				default: () => {
					return 0
				}
			},


		},
		data() {
			return {
				loading: true,
				pdfurl: null,
				pdfpage: 1,
				modalShow: false,
				htmlContent: '',
				title: '',
				targetnode: [],
				hasseal: false,
				contextMenuData: {},
				menuKey: 0,
				menuShow: false,
				watermark: [],
				seal: [],
				cuttentsealid: 0,
				cuttentsealobj: null,
				startOffset: {
					x: 0,
					y: 0
				}
			}
		},
		watch: {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			init() {
				this.pdfurl = null
				this.hasseal = this.row.audit == 5 ? true : false
				this.targetnode = []
				const wordarticle = this.$refs.wordarticle
				wordarticle.scrollTop = 0
				let file = this.row.file[0]
				let getFileType = this.getFileType(file)
				if(getFileType){
					this.title = this.row.name
					this.$api.upload.download({
						path: file.path,
						name: file.name,
						filetype: getFileType
					}).then((res) => {
						if (getFileType != 'PDF') {
							this.previewDOCX(res)
						} else {
							this.previewPDF(file)
						}
						this.seal = this.row.seal ? this.row.seal : []
						this.loading = false
					
					})
				}else{
					this.loading = false
				}

			},
			getstaff(value) {
				return window.systemMethods.getstaff(value)
			},
			timestampToDate(value) {
				return window.systemMethods.timestampToDate(value)
			},

			setContextMenuData(e, type, id = null) {
				if (this.type != 'audit') {
					return
				}
				if (type == 'add') {
					this.contextMenuData = {
						menuName: 'menu',
						axis: {
							x: null,
							y: null
						},
						menulists: [{
							btnName: "添加公章",
							fnHandler: "addseal",
							icoName: "el-icon-edit-outline"
						}, {
							btnName: "清空",
							fnHandler: "clear",
							icoName: "el-icon-edit-outline"
						}]
					}
				}
				if (type == 'del') {
					this.cuttentsealid = id
					this.contextMenuData = {
						menuName: 'menu',
						axis: {
							x: null,
							y: null
						},
						menulists: [{
							btnName: "删除公章",
							fnHandler: "delseal",
							icoName: "el-icon-edit-outline"
						}]
					}
				}
				this.menuKey = Math.random()
				this.$nextTick(() => {
					this.showMenu(e)
				})
			},
			showMenu(e) {
				let x = e.clientX
				let y = e.clientY
				this.contextMenuData.axis = {
					x,
					y
				}
				this.menuShow = true
			},
			addseal(obj = null) {
				return new Promise((reslove) => {
					let targetTag = document.getElementById('audit_preload_box')
					let tagbound = targetTag.getBoundingClientRect()
					this.$api.company.getseal(this.comapnyid).then((res) => {
						if (!res || res.length == 0) {
							this.$message.error('电子章未获取')
							reslove()
							return
						}
						if (!obj) {
							this.seal.push({
								id: Math.random(),
								x: this.contextMenuData.axis.x - tagbound.x - 50,
								y: this.contextMenuData.axis.y - tagbound.y - 50,
								url: res[0].url
							})
						} else {
							this.seal.push({
								id: Math.random(),
								x: obj.x - tagbound.x - 50,
								y: obj.y - tagbound.y - 50,
								url: res[0].url
							})
						}
						reslove()
						// let res = this.textToBase64Image(this.$store.state.system.user.name, 200, 50)	
						// console.log(res)

						// let imgNode = document.createElement("img");
						// imgNode.classList.add("zhang")
						// imgNode.src = res[0].url + '?' + Math.random(); // 用你的图片 URL 替换这里
						// imgNode.style = "position: absolute;width:100px;left:" + (this.contextMenuData.axis.x -
						// 	tagbound.x - 50) + "px;top:" + (this.contextMenuData.axis.y - tagbound.y - 50) + "px;"
						// targetTag.appendChild(imgNode)
					})
				})
			},
			delseal() {
				let seal = this.seal
				let index = seal.findIndex((item) => {
					return item.id == this.cuttentsealid
				})
				if (index !== -1) {
					seal.splice(index, 1)
				}
				if (seal.length == 0) {
					this.row.commit_time = ''
					this.row.auditorstaffid = ''
				}
				this.seal = seal
			},
			movestart(e, id) {

				if (this.type != 'audit') {
					return
				}
				let obj = this.seal.find((item) => {
					return item.id == id
				})
				if (obj) {
					this.cuttentsealobj = obj

					this.startOffset = {
						x: this.cuttentsealobj.x - e.clientX,
						y: this.cuttentsealobj.y - e.clientY
					}
				} else {
					this.cuttentsealobj = null
				}

			},
			moveing(e) {
				if (this.type != 'audit') {
					return
				}
				if (this.cuttentsealobj) {
					this.cuttentsealobj.x = e.clientX + this.startOffset.x
					this.cuttentsealobj.y = e.clientY + this.startOffset.y
				}
			},
			moveend() {
				this.cuttentsealobj = null
				this.startOffset = {
					x: 0,
					y: 0
				}
			},

			//http://47.98.231.105/api/public/storage/company/20230731/fb59897377b510c9e1c55c813769808a.png
			previewDOCX(res) {
				let blob = new Blob([res.data])
				let reader = new FileReader()
				reader.readAsArrayBuffer(new window.File([blob], res.name, {
					type: 'blob'
				}))
				reader.onload = (e) => {
					let data = e.target.result
					renderAsync(data, document.getElementById("audit_preload_box"), null, {
						className: "docx", // 默认和文档样式类的类名/前缀
						inWrapper: false, // 启用围绕文档内容渲染包装器
						ignoreWidth: false, // 禁止页面渲染宽度
						ignoreHeight: false, // 禁止页面渲染高度
						ignoreFonts: false, // 禁止字体渲染
						breakPages: true, // 在分页符上启用分页
						ignoreLastRenderedPageBreak: true, //禁用lastRenderedPageBreak元素的分页
						experimental: false, //启用实验性功能（制表符停止计算）
						trimXmlDeclaration: true, //如果为真，xml声明将在解析之前从xml文档中删除
						debug: false, // 启用额外的日志记录
					}).then(() => {
						let targetTag = document.getElementsByTagName('article')
						this.findElementWithText(targetTag[0], '盖章区')
						this.targetnode.forEach((node) => {
							if (this.type == 'audit' && this.seal.length == 0) {
								let rect = node.getBoundingClientRect()
								this.addseal({
									x: rect.x,
									y: rect.y
								}).then(() => {
									if (this.seal.length != 0) {
										node.innerHTML = "";
									}
								})
							}
							if (this.seal.length != 0) {
								node.innerHTML = "";
							}

						})
					})
				}
			},
			previewPDF(file) {
				let path = file.path
				if (!path.includes('https')) {
					path = file.path.replace("http", "https")
				}
				let loadingTask = pdf.createLoadingTask(path);
	
				loadingTask.promise.then(Pdf => {
					this.pdfurl = loadingTask
					this.pdfpage = Pdf._pdfInfo.numPages
				}).catch(() => {
					console.error('pdf加载失败')
				})
				//this.pdfurl = file.path

			},
			findElementWithText(node, string) {
				if (node.nodeType === 1 && node.textContent.includes(string)) { // 检查节点类型是否为元素节点
					if (node.innerHTML == string) {
						this.targetnode.push(node)

					}
				}
				for (let i = 0; i < node.childNodes.length; i++) {
					let result = this.findElementWithText(node.childNodes[i], string)
					if (result) {
						return result
					}
				}
				return null
			},
			async download() {
				this.loading = true
				let numPages = 0
				let pageWidth = 0
				let pageHeight = 0
				let model = this.$refs.contract_box
				let rect = model.getBoundingClientRect()
				let PDF = new jsPDF('p', 'mm', 'a4')
				let timeStamp = new Date().getTime()
				let date = window.systemMethods.timestampToDate(timeStamp, true)
				let title = this.row.name + date
				let pages = document.querySelectorAll('.pdfPage')
				let param = this.calculateNumPages(rect)

				if (pages.length != 0) {
					numPages = pages.length
					pageWidth = pages[0].getBoundingClientRect().width
					pageHeight = pages[0].getBoundingClientRect().height
				} else {
					numPages = param.numPages
					pageWidth = rect.width
					pageHeight = param.pageHeight
				}
				console.log(numPages, pageWidth, pageHeight)
				const processPages = async () => {
					for (let index = 0; index < numPages; index++) {
						if (index > 0) {
							PDF.addPage();
						}
						await this.createPdf(model, pageWidth, pageHeight, index, PDF);
						if (index === numPages - 1) {
							PDF.save(title + '.pdf');
							this.loading = false
						}
					}
				}
				await processPages()
			},
			createPdf(model, pageWidth, pageHeight, index, PDF) {
				let scale = 1
				return new Promise((reslove) => {
					html2canvas(model, {
						useCORS: true,
						scale: scale,
						y: index * pageHeight,
						height: pageHeight
					}).then((canvas) => {
						let pdfWidth = PDF.internal.pageSize.getWidth()
						let pdfHeight = PDF.internal.pageSize.getHeight()
						pdfHeight = pdfWidth/pageWidth * pageHeight
						let pageData = canvas.toDataURL('image/png', 1.0)
						PDF.addImage(pageData, 'PNG', 0, 0, pdfWidth, pdfHeight, '', 'NONE')
						reslove()
					})
				})
			},
			calculateNumPages(rect) {
				let a4Width = 595
				let a4Height = 842
				let divHeight = rect.height
				let pageWidth = rect.height / a4Height * a4Width
				let pageHeight  = rect.width / a4Width * a4Height

				let numPages = Math.ceil(divHeight / pageHeight)
				return {
					numPages: numPages,
					pageWidth: pageWidth,
					pageHeight: pageHeight
				}
			},
			submit() {

				if (this.seal.length != 0) {
					this.row.audit = 5
					this.row.seal = this.seal
					this.row.commit_time = Math.floor(new Date().getTime())
					this.row.auditorstaffid = this.$store.state.system.user.id
					this.modalShow = false
				} else {
					this.row.audit = 6
					this.$message.error('缺少公章')
				}
			},
			cancle() {

				this.seal = []
				this.row.seal = []
				this.row.audit = 6
				this.row.commit_time = null
				this.row.auditorstaffid = null
				this.modalShow = false
			},
			clear() {
				this.seal = []
			},
			getFileType(file) {
				if(file){
					let filetype = file.name.split('.')
					filetype = filetype[filetype.length - 1]
					return filetype.toUpperCase()
				}
				return null

			},
			previewHide() {
				this.seal = []
				this.loading = true
			},
			// textToBase64Image(text, width, height) {
			// 	const canvas = document.createElement('canvas');
			// 	canvas.width = width; // 设置Canvas宽度
			// 	canvas.height = height; // 设置Canvas高度
			// 	const ctx = canvas.getContext('2d');
			// 	ctx.font = '20px Arial'; // 设置文本字体和大小
			// 	ctx.fillStyle = '#fff'; // 设置文本颜色
			// 	ctx.fillText(text, 10, 30); // 渲染文本到Canvas上
			// 	const base64Image = canvas.toDataURL('image/png'); // 将Canvas转换为Base64编码的图像
			// 	return base64Image;
			// }
		},
		components: {
			pdf
		}
	}
</script>